var Clock = function () {

    var $clocks;
    var prefixes = ['-ms-','-webkit-','-moz-'];

    function init () {
        $clocks = $('.clock-block');
        $clocks.toArray().map($).forEach(function ($el) {
            let $svg = $el.find('svg');
            let utcOffset = $el.data().utcOffset;
            let clock = new Clock($svg, utcOffset);
            clock.start();
            updateAMPM($el, utcOffset);
            setInterval(function () {
                updateAMPM($el, utcOffset);
            }, 10000);
        });
    }

    class Clock {
        constructor (svgRoot, timeOffsetHours) {
            this.el = svgRoot;
            this.offset = timeOffsetHours;
            this.seconds = svgRoot.find('.secondhand');
            this.minutes = svgRoot.find('.minutehand');
            this.hours = svgRoot.find('.hourhand');
            this.intervalID;
        }

        start () {
            clearInterval(this.intervalID);
            setInterval(() => {
                requestAnimationFrame(() => {
                    this.update();
                });
            }, 1000);
        }

        update () {
            let date = makeLocalDate(this.offset);
            let hoursAngle = 360 / 12 * date.getHours() + date.getMinutes() / 2;
            let minuteAngle = 360 * date.getMinutes() / 60;
            let secAngle = 360 * date.getSeconds() / 60;

            this.hours.attr('transform', makeSVGTransformFunction(hoursAngle));
            this.minutes.attr('transform', makeSVGTransformFunction(minuteAngle));
            this.seconds.attr('transform', makeSVGTransformFunction(secAngle));
        }

        stop () {
            clearInterval(this.intervalID);
        }

    }

    function makeSVGTransformFunction (deg) {
        return 'rotate(' + deg + ')';
    }

    function makeLocalDate (timeOffsetHours) {
        var date = new Date(convertDateToUTC(new Date()));
        var dst = date.dst() ? 1 : 0;
        date = new Date( date.setHours( date.getHours() + timeOffsetHours + dst ) );
        return date;
    }

    function updateAMPM ($el, timeOffsetHours) {
        var date = makeLocalDate(timeOffsetHours);
        var $text = $el.find('.am-pm');
        $text.text( date.getHours() > 12 ? 'PM' : 'AM' );
    }

    function convertDateToUTC (date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    return {
        init: init
    }

}()

Date.prototype.stdTimezoneOffset = function() {
    var jan = new Date(this.getFullYear(), 0, 1);
    var jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.dst = function() {
    return this.getTimezoneOffset() < this.stdTimezoneOffset();
}
